<p *ngFor="let key of keys" class="my-1">
  <span *ngIf="json[key]">
    {{ key | replaceUnderscoreWithSpace | firstLetterUppercase }}: {{ json[key] | dateObjectToString }}
  </span>
</p>